import { CONSIGNMENT_BRANCH_SETTING_TAB } from "@/core/helpers/consignmentBranchSettingTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Shown as a Stores & Teams tab.
export const Route = createFileRoute("/admin/consignment-admin-team/")({
	beforeLoad() {
		throw redirect({
			to: "/admin/consignment-branch-setting",
			search: { tab: CONSIGNMENT_BRANCH_SETTING_TAB.Teams },
			replace: true,
		});
	},
});
